<div class="chat-invitation-container">

  <div class="chat-invitation__image-container">
    @if(conversation.status === ConversationStatus.TO_ASSIGN){
      <img src="./assets/layout/to_assign.svg" style="height: 32vh">
    } @else {
      <img src="./assets/layout/pending.svg" style="height: 32vh">
    }
  </div>
  <p class="text-xl font-light mb-1"><span class="font-medium">Contatto: </span> {{ conversation.contact | contactDisplay: conversation.fromNumber }}</p>
  @if(conversation.status === ConversationStatus.TO_ASSIGN){
    <p>Questa conversazione ti e' stata assegnata automaticamente. Clicca procedi per prenderla in carico</p>
  } @else {
    <p>Vuoi prendere in carico questa conversazione o vuoi
      rifiutarla?</p>
  }
  <div class="mt-2">
    @if(conversation.status === ConversationStatus.TO_ASSIGN){
      <p-button label="Procedi" severity="success"  outlined="outlined" icon="pi pi-check-circle" class="me-3" (onClick)="onChoice(true)"/>
    } @else {
      <p-button label="Accetta" severity="success"  outlined="outlined" icon="pi pi-check-circle" class="me-3" (onClick)="onChoice(true)"/>
      <p-button label="Rifiuta" severity="danger"  outlined="outlined" icon="pi pi-times-circle" (onClick)="onChoice(false)"/>
    }
  </div>
</div>

